/**
 * The service for web sockets.
 * Contains the logic for initializing, connecting and disconnecting web sockets using stomp over sock.
 */
export class WebSocketsService {
    /*@ngInject*/
    constructor($q, $rootScope, $timeout, StorageService) {
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.StorageService = StorageService;
        this.urlConstants = {
            WEB_SOCKET_CONNECTION_URL: 'register',
            ECHO_URL: '/topic/echo',
            USER_NOTIFICATIONS: '/queue/{userId}/notifications',
            MESSAGE_NOTIFICATIONS: '/queue/{userId}/chatMessage',
            WORKFLOW_UPDATE: '/queue/{userId}/workflowUpdate',
            SEND_URL: '/send/url',
            WEB_SOCKET_CONNECTION_URL_FOR_CHIME: 'register/chime',
            CHIME_NOTIFICATIONS: '/chime/{participantId}/notifications'
        };
        this.chimeParticipantId = null;
        this.isChimeListenerListening = false;
        this.listener = this.$q.defer();
        this.listenerForChime = this.$q.defer();
        this.messageListener = this.$q.defer();
        this.workflowUpdateListener = this.$q.defer();
        this.socket = {
            client: null,
            stomp: null
        };
        this.socketForChime = {
            client: null,
            stomp: null
        };
        this.messageIds = [];
        this.reconnect = () => {
            this.$timeout(() => {
                this.initialize();
            }, 6000);
        };
        this.reconnectForChime = () => {
            this.$timeout(() => {
                this.initializeForChime();
            }, 6000);
        };
        this.initialize = () => {
            if ((_.isNull(this.socket.stomp) || !this.socket.stomp.connected) && this.StorageService.get('userDetails')) {
                this.socket.client = new SockJS(this.StorageService.get('baseurl') + this.urlConstants.WEB_SOCKET_CONNECTION_URL);
                this.socket.stomp = Stomp.over(this.socket.client);
                this.socket.stomp.connect({}, this.startListener, this.reconnect);
            }
        };
        this.initializeForChime = () => {
            if ((_.isNull(this.socketForChime.stomp) || !this.socketForChime.stomp.connected)) {
                this.socketForChime.client = new SockJS(this.StorageService.get('baseurl') + this.urlConstants.WEB_SOCKET_CONNECTION_URL_FOR_CHIME);
                this.socketForChime.stomp = Stomp.over(this.socketForChime.client);
                this.socketForChime.stomp.connect({}, this.startListenerForChime, this.reconnectForChime);
            }
        };
        this.getMessage = (data) => {
            let message = JSON.parse(data.body);
            return message;
        };
        this.disconnect = () => {
            if (!_.isNull(this.socket.stomp) && this.socket.stomp.connected) {
                this.socket.stomp.disconnect(() => {
                    console.log("Web socket disconnected.");
                });
            }
        };
        this.disconnectForChime = () => {
            if (!_.isNull(this.socketForChime.stomp) && this.socketForChime.stomp.connected) {
                this.socketForChime.stomp.disconnect(() => {
                    console.log("Web socket for chime disconnected.");
                });
            }
        };
        this.startListener = () => {
            this.socket.stomp.subscribe(this.urlConstants.USER_NOTIFICATIONS.replace('{userId}', this.$rootScope.userDetails.id), (data) => {
                this.listener.notify(this.getMessage(data));
            });
            this.socket.stomp.subscribe(this.urlConstants.MESSAGE_NOTIFICATIONS.replace('{userId}', this.$rootScope.userDetails.id), (data) => {
                this.messageListener.notify(this.getMessage(data));
            });
            this.socket.stomp.subscribe(this.urlConstants.WORKFLOW_UPDATE.replace('{userId}', this.$rootScope.userDetails.id), (data) => {
                console.log('Workflow Update alert:');
                console.log(this.getMessage(data));
                this.workflowUpdateListener.notify(this.getMessage(data));
            });
        };
        this.startListenerForChime = () => {
            this.$rootScope.$emit("CHIME_WEBSOCKET_CONNECTED", null);
            this.socketForChime.stomp.subscribe(this.urlConstants.CHIME_NOTIFICATIONS.replace('{participantId}', this.chimeParticipantId), (data) => {
                this.listenerForChime.notify(this.getMessage(data));
            });
        };
    }
    connect() {
        this.initialize();
    }
    connectForChime(chimeParticipantId) {
        this.chimeParticipantId = chimeParticipantId;
        this.initializeForChime();
    }
    receive() {
        return this.listener.promise;
    }
    receiveMessage() {
        return this.messageListener.promise;
    }
    receiveWorkflowUpdate() {
        return this.workflowUpdateListener.promise;
    }
    receiveChimeNotification() {
        this.isChimeListenerListening = true;
        return this.listenerForChime.promise;
    }
    send(message) {
        let id = Math.floor(Math.random() * 1000000);
        this.socket.stomp.send(this.urlConstants.SEND_URL, {
            priority: 9
        }, JSON.stringify({
            message: message,
            id: id
        }));
        this.messageIds.push(id);
    }
    setWorkflowUpdateListener() {
        this.workflowUpdateListener = this.$q.defer();
    }
    resetWorkflowUpdateListener() {
        this.workflowUpdateListener.resolve();
        this.setWorkflowUpdateListener();
    }
}
//# sourceMappingURL=webSocketsService.js.map